<div class="email__container">
  <div class="email__form">
    <app-select-email-template [(document)]="document" [user]="currentUser" [isNewDocument]="isNewDocument" (emailTemplateChange)="emailTemplateSelected = $event"></app-select-email-template>

    <label
      class="field__holder textarea"
      [class.error]="validationErrors?.document?.message"
      #DocumentMessageTooltip="ngbTooltip"
      triggers="focus"
      [autoClose]="true"
      [ngbTooltip]="tipDocumentMessage"
      container="body"
      placement="right"
    >
      <textarea class="field none" type="text" [class.empty]="false" [(ngModel)]="document.message" (focus)="DocumentMessageTooltip.toggle()" (ngModelChange)="updateEmailTemplate()"></textarea>
      <span class="field__placeholder">{{ 'documents.messageToSignatories' | translate }} </span>
      <p [hidden]="!validationErrors?.document?.message" class="field__error-message">{{ validationErrors?.document?.message }}</p>
    </label>
  </div>

  <div class="configuration-mail dick butt forceDefaultColors" *ngIf="currentUser && emailTemplateSelected">
    <div class="configuration-mail-bar">
      <div class="dot"></div>
    </div>
    <div class="configuration-mail-title forceDefaultColors">
      <div class="configuration-mail-title-field">{{ emailTemplateSelected[selectedLang].subject }}</div>
    </div>
    <div class="configuration-mail-signatory forceDefaultColors">
      <div class="configuration-mail-signatory-field">{{ emailTemplateSelected[selectedLang].sender }}</div>
    </div>
    <div class="configuration-mail-body">
      <app-signature-email-preview
        [user]="currentUser"
        [selectedLang]="selectedLang"
        [emailType]="emailTemplateSelected.type"
        [emailSettings]="emailTemplateSelected[selectedLang]"
      ></app-signature-email-preview>
    </div>
  </div>
</div>

<ng-template #tipDocumentMessage>
  <div class="tooltip__title">{{ 'documents.messageToSignatories' | translate }}</div>
  <div class="tooltip__descr">{{ 'documents.messageToSignatoriesDescription' | translate }}</div>
</ng-template>
